import React, { type FC, useState } from 'react';
import classnames from 'classnames';
import { JournalText } from 'react-bootstrap-icons';
import { Trans, useTranslation } from 'react-i18next';

import type { IPrice, IUnit } from 'api/types';
import WiseModal from 'components/wise/WiseModal';
import WiseAddToShoppingListForm from 'components/wise/WiseAddToShoppingListForm';

import styles from 'theme/components/wise/WiseAddToShoppingListButton/WiseAddToShoppingListButton.module.scss';

export type WiseAddToShoppingListButtonProps = {
  unit?: IPrice | IUnit;
  quantity: number;
  openModal?: boolean;
  setOpenModal?: React.Dispatch<React.SetStateAction<boolean>>;
  product_id?: number;
  unit_id?: number;
  image?: string;
  title?: string;
  index?: string;
  currency?: string;
  triggerClassName?: string;
};

const WiseAddToShoppingListButton: FC<WiseAddToShoppingListButtonProps> = ({
  unit,
  quantity,
  openModal,
  setOpenModal,
  product_id,
  unit_id,
  image,
  title,
  index,
  currency,
  triggerClassName
}) => {
  const { t } = useTranslation();
  const [internalOpen, setInternalOpen] = useState(false);

  const isOpen = openModal ?? internalOpen;
  const setOpen = setOpenModal ?? setInternalOpen;

  return (
    <div
      className={classnames(
        styles.root,
        'StylePath-Components-Wise-WiseAddToShoppingListButton'
      )}>
      <div
        className={classnames(styles.trigger, triggerClassName)}
        onClick={() => setOpen(true)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setOpen(true);
          }
        }}
        role="button"
        tabIndex={0}>
        <JournalText />
        <Trans>Dodaj do listy</Trans>
      </div>

      {isOpen && (
        <WiseModal
          open={isOpen}
          onClose={() => setOpen(false)}
          title={t('Dodawanie produktów do listy zakupowej')}
          maxWidth={980}>
          <WiseAddToShoppingListForm
            items={[
              {
                quantity,
                price_net_formatted: (unit as IPrice | undefined)?.price_net_formatted,
                price_gross_formatted: (unit as IPrice | undefined)?.price_gross_formatted,
                product_id,
                unit_id,
                image,
                title,
                index,
                currency
              }
            ]}
            onCancel={() => setOpen(false)}
          />
        </WiseModal>
      )}
    </div>
  );
};

export default WiseAddToShoppingListButton;

